import { render, staticRenderFns } from "./NamelistDetailForm.vue?vue&type=template&id=96e1d5b8&"
import script from "./NamelistDetailForm.vue?vue&type=script&lang=js&"
export * from "./NamelistDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports